export default "__VITE_ASSET__CVx_5dNy__"